import createStore from "teaful"
import SegmentTitles from "../data/SegmentTitles.json"
import { addPageView } from "../apis/googleAnalytics"
import {
  diff,
  addedDiff,
  deletedDiff,
  updatedDiff,
  detailedDiff,
} from "deep-object-diff"
import { validateVersion } from '../scripts/validateVersion'

const isBrowser = typeof window !== "undefined"

const initialState = {
  AvailableContent: null,
  translations: null,
  displayRef:
    isBrowser && localStorage.getItem("displayRef") === "true" ? true : false,
  interlinear:
    isBrowser && localStorage.getItem("interlinear") === "true" ? true : false,
  showSpheres:
    isBrowser && localStorage.getItem("showSpheres") === "true" ? true : false,
  showValues:
    isBrowser && localStorage.getItem("showValues") === "true" ? true : false,
  showVerbs:
    isBrowser && localStorage.getItem("showVerbs") === "true" ? true : false,
  showCurrentRef:
    isBrowser && localStorage.getItem("showCurrentRef") === "true"
      ? true
      : false,
  showTimePeriod:
    isBrowser && localStorage.getItem("showTimePeriod") === "true"
      ? true
      : false,
  showQA: isBrowser && localStorage.getItem("showQA") === "true" ? true : false,
  showGAP:
    isBrowser && localStorage.getItem("showGAP") === "true" ? true : false,
  version: (() => {
    return isBrowser && localStorage.getItem("currentVersion")
      ? localStorage.getItem("currentVersion")
      : "NLT"
  })(),
  language:
    isBrowser && localStorage.getItem("currentLanguage")
      ? localStorage.getItem("currentLanguage")
      : "ENG",
  currentBook:
    isBrowser && SegmentTitles[localStorage.getItem("currentSegment")]
      ? SegmentTitles[localStorage.getItem("currentSegment")].book[0]
      : null,
  currentSegmentID: (() => {
    // addPageView(
    //   `/reader/#${localStorage.getItem("currentLanguage") ||
    //     "ENG"}-${localStorage.getItem("currentVersion") ||
    //     "NLT"}-${localStorage.getItem("currentSegment") || "S001"}`
    // )
    return isBrowser && localStorage.getItem("currentSegment")
      ? localStorage.getItem("currentSegment")
      : "S001"
  })(),
  searchID: "",
  currentSphere: "",
  currentKeyPassage: "",
  currentValue: "",
  currentValuePassage: "",
  refID: "",
  history: [],
  scrollY: 0,
  segmentOrder: "Bible",
  metadata: null,
  readPlan: null,
  readPlanID: 0,
  showGAPPopup: false,
  NoMoreGAPPopup:
    isBrowser && localStorage.getItem("NoMoreGAPPopup") === "true"
      ? true
      : false,
}


export const { useStore, getStore, withStore } = createStore(
  initialState,
  onAfterUpdate
)

function onAfterUpdate({ store, prevStore }) {
  const {
    AvailableContent,
    displayRef,
    interlinear,
    showSpheres,
    showValues,
    showVerbs,
    showCurrentRef,
    showTimePeriod,
    showQA,
    showGAP,
    version,
    language,
    language_code,
    currentBook,
    currentSegmentID,
    NoMoreGAPPopup,
  } = store

  // Show change in state
  // console.log("detailedDiff:", detailedDiff(prevStore, store))

  // if state is updated...
  const { updated } = detailedDiff(prevStore, store);

  // if language, version or segment are updated, update the url
  if (updated && updated.language && window) {
    window.location.hash = `${language}-${version}-${currentSegmentID}`
  }
  if (updated && updated.version && window) {
    window.location.hash = `${language}-${version}-${currentSegmentID}`
    if (
      (window.location.pathname === "/reader" ||
        window.location.pathname === "/reader/") &&
      validateVersion(AvailableContent, language, version)
    ) {
      addPageView(`/reader/#${language}-${version}-${currentSegmentID}`)
    }

  }
  if (updated && updated.currentSegmentID && window) {
    window.location.hash = `${language}-${version}-${currentSegmentID}`
    addPageView(`/reader/#${language}-${version}-${currentSegmentID}`)
  }

  if (isBrowser) {
    // set the localStorage saved state settings
    localStorage.setItem("displayRef", displayRef)
    localStorage.setItem("interlinear", interlinear)
    localStorage.setItem("showSpheres", showSpheres)
    localStorage.setItem("showValues", showValues)
    localStorage.setItem("showVerbs", showVerbs)
    localStorage.setItem("showCurrentRef", showCurrentRef)
    localStorage.setItem("showTimePeriod", showTimePeriod)
    localStorage.setItem("showQA", showQA)
    localStorage.setItem("showGAP", showGAP)
    localStorage.setItem("currentVersion", version)
    localStorage.setItem("currentLanguage", language)
    localStorage.setItem("currentBook", currentBook)
    localStorage.setItem("currentSegment", currentSegmentID)
  }
}
